import { ReactNode } from "react";
import { TabsList } from "@focal/ui-kit";
import { cn } from "@/lib/utils";

interface UnderlinedTabsListProps {
  /** Tabs triggers, rendered inline. */
  children: ReactNode;
  /**
   * Optional class names to append. Defaults to no horizontal padding so the
   * tab triggers align with the parent container's left edge (which is what
   * settings pages and details pages want). On list pages where the surrounding
   * wrapper uses a negative margin to bleed past `MainContainer`'s padding,
   * pass `className="px-4"` to restore visual alignment with the page header.
   */
  className?: string;
}

/**
 * Shared TabsList preset used across list, settings, and details pages.
 * Renders an underlined bar styled to match the design system's underlined
 * tab variant. Pair with `<TabsTrigger variant="underlined" />` children.
 */
export const UnderlinedTabsList = ({
  children,
  className,
}: UnderlinedTabsListProps) => (
  <TabsList
    className={cn(
      "flex py-0! mb-6 items-end justify-start border-b border-border rounded-none pl-0",
      className,
    )}
  >
    {children}
  </TabsList>
);
